import React, { useEffect, useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../config";

export default function TeacherBoards() {
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(true);
  const teacherEmail = localStorage.getItem("teacherEmail") || "default@example.com";

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const response = await axios.get(
          `${buildApiUrl("")}/api/whiteboard/teacher/${teacherEmail}`
        );
        setBoards(response.data);
      } catch (error) {
        console.error("Failed to load whiteboards:", error);
        alert("Failed to load whiteboards");
      } finally {
        setLoading(false);
      }
    };

    fetchBoards();
  }, [teacherEmail]);

  const handlePreview = (board) => {
    try {
      // Create a proper Excalidraw file format
      const excalidrawData = {
        type: "excalidraw",
        version: 2,
        source: "https://excalidraw.com",
        elements: board.elements,
        appState: {
          gridSize: null,
          viewBackgroundColor: "#ffffff"
        },
        files: board.files || {}  // ✅ Include files for images
      };

      // Convert to JSON string and encode for URL
      const jsonString = JSON.stringify(excalidrawData);
      const encodedData = encodeURIComponent(jsonString);
      
      // Open in new tab with the encoded data
      window.open(`https://excalidraw.com/#json=${encodedData}`, "_blank");
    } catch (error) {
      console.error("Failed to preview whiteboard:", error);
      alert("Failed to preview whiteboard");
    }
  };

  const handleDownload = (board) => {
    try {
      const excalidrawData = {
        type: "excalidraw",
        version: 2,
        source: "https://excalidraw.com",
        elements: board.elements,
        appState: {
          gridSize: null,
          viewBackgroundColor: "#ffffff"
        },
        files: board.files || {}  // ✅ Include files for images
      };

      const dataStr = JSON.stringify(excalidrawData, null, 2);
      const dataBlob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(dataBlob);
      
      const link = document.createElement("a");
      link.href = url;
      link.download = `${board.title.replace(/[^a-z0-9]/gi, '_')}.excalidraw`;
      link.click();
      
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download whiteboard:", error);
      alert("Failed to download whiteboard");
    }
  };

  const handleDelete = async (board, index) => {
    if (!window.confirm(`Are you sure you want to delete "${board.title}"?`)) {
      return;
    }

    try {
      // You'll need to add a delete endpoint to your backend
      await axios.delete(`${buildApiUrl("")}/api/whiteboard/${board.id}`);
      
      // Remove from local state
      setBoards(boards.filter((_, i) => i !== index));
      alert("Whiteboard deleted successfully");
    } catch (error) {
      console.error("Failed to delete whiteboard:", error);
      alert("Failed to delete whiteboard");
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="text-center">Loading your whiteboards...</div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Your Saved Whiteboards</h2>
        <span className="text-gray-600">{boards.length} whiteboard(s)</span>
      </div>

      {boards.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 mb-4">No whiteboards saved yet.</p>
          <p className="text-sm text-gray-400">
            Create and save whiteboards from the Whiteboard tab to see them here.
          </p>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {boards.map((board, index) => (
            <div
              key={index}
              className="border rounded-lg p-4 shadow hover:shadow-md transition-shadow"
            >
              <div className="mb-3">
                <h3 className="text-lg font-semibold truncate" title={board.title}>
                  {board.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  Assigned to: <span className="font-medium">{board.form}</span>
                </p>
              </div>
              
              <div className="flex gap-2 flex-wrap">
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded text-sm transition-colors"
                  onClick={() => handlePreview(board)}
                >
                  Preview
                </button>
                
                <button
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded text-sm transition-colors"
                  onClick={() => handleDownload(board)}
                >
                  Download
                </button>
                
                <button
                  className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded text-sm transition-colors"
                  onClick={() => handleDelete(board, index)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}